import {graphql} from 'react-relay';

export default graphql`
    query footerRootQuery(
        $hasUserId: Boolean!
        $userId: String!
    ) {
        viewer {
            ...Footer_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    userId: ''
};



// WEBPACK FOOTER //
// ./src/queries/footerRootQuery.js